const facts = [
  "AI is truly revolutionizing various aspects of our lives and industries",
  "Deep learning models require massive datasets for training",
  "A McKinsey survey from 2021 found that 56% of companies have adopted AI in at least one function within the organization",
  "A strong password should be at least 12-16 characters long",
  "AI strategy by NTT DATA, which supports companies in defining their AI journey and leveraging industry-specific knowledge",
  "AIOps  platform uses advanced analytics and machine learning capabilities to automate routine tasks, predict issues, and drive faster resolution",
  "Phishing attacks cause 90% of data breaches",
  "Syntphony is a collection of apps inspired by music and tuned for business. It is part of the NTT DATA Product Composable Platform",
  "AI-powered chatbots are now used for customer service worldwide",
  "Nucleus is a platform offers a variety of products built upon delivery",
  "AI can now compose music, write stories, and generate images",
  "The first AI program was written in 1951 by Christopher Strachey",
  "The term 'Artificial Intelligence' was coined in 1956",
  "Multi-factor authentication significantly enhances security",
  "The world's first programmer was Ada Lovelace in the 1800s",
  "Deep learning models require massive datasets for training",
  "A McKinsey survey from 2021 found that 56% of companies have adopted AI in at least one function within the organization",
  "A strong password should be at least 12-16 characters long",
  "AI strategy by NTT DATA, which supports companies in defining their AI journey and leveraging industry-specific knowledge",
  "AIOps  platform uses advanced analytics and machine learning capabilities to automate routine tasks, predict issues, and drive faster resolution",
  "Phishing attacks cause 90% of data breaches",
  "Syntphony is a collection of apps inspired by music and tuned for business. It is part of the NTT DATA Product Composable Platform",
  "AI-powered chatbots are now used for customer service worldwide",
  "Nucleus is a platform offers a variety of products built upon delivery",
  "AI can now compose music, write stories, and generate images",
  "The first AI program was written in 1951 by Christopher Strachey",
  "The term 'Artificial Intelligence' was coined in 1956",
  "Multi-factor authentication significantly enhances security",
  "The world's first programmer was Ada Lovelace in the 1800s",
];

const pastelColors = ["black"];

export const getRandomFact = (count = 10) => {
  const uniqueFacts = Array.from(new Set(facts));
  if (count > uniqueFacts.length) count = uniqueFacts.length;
  const shuffled = uniqueFacts.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count).map((fact) => {
    const colorClass =
      pastelColors[Math.floor(Math.random() * pastelColors.length)];
    return { fact, colorClass };
  });
};
